import React from 'react'
import { useSelector } from "react-redux";

import {
  Chart as ChartJs,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js/auto'

import { Bar } from 'react-chartjs-2';
ChartJs.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
)

export default function BarChart({ dashboardId }) {

  const dashboardData = useSelector(state => state.dashboardReducer.userDashboard.userdashboardData);
  if (dashboardData === null) {
    return <div />;
  }
  let datas = dashboardData[dashboardId];
  let dataRows = datas.dataRows;
  if(dataRows.length===0){
    return <div></div>;
  }

  // Group the data by label and series description
  const groupedData = dataRows.reduce((acc, curr) => {
    const label = curr.fields.find(field => field.fieldName === 'CHARTLABEL').fieldValue;
    const value = curr.fields.find(field => field.fieldName === 'CHARTVALUE').fieldValue;
    const series = curr.fields.find(field => field.fieldName === 'SERIESDESC').fieldValue;

    if (!acc[label]) {
      acc[label] = {};
    }

    acc[label][series] = value;

    return acc;
  }, {});

  function getRandomColor(alpha = 1) {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  const labels = Object.keys(groupedData).sort(); // Sort labels in ascending order
  const datasets = Object.keys(groupedData).map(series => ({
    label: series,
    backgroundColor: getRandomColor(0.6),
    borderColor: getRandomColor(),
    hoverBackgroundColor: getRandomColor(0.8),
    hoverBorderColor: getRandomColor(),
    data: labels.map(label => groupedData[label][series] )
  }));
  const options = {
    indexAxis: 'y',
    scales: {
      x: {
          stacked: true
      },
      y: {
          stacked: true
      }
  },
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
      tooltip: {
        enabled: true, // Disable tooltips, we'll use custom labels
      },
    },
  };
  return (
    <div class="col-xl-6 col-lg-6">
      <div class="card">
        <div class="card-body">
        <div className="alert alert-primary" role="alert">
                        <h4> <i className='mdi mdi-chart-bar'></i> {datas.dashboardTitle} </h4>
                    </div>
          <div dir="ltr">
            <Bar data={{ labels, datasets }} options={options} />
          </div>
        </div>
        {/* <div class="chart-widget-list">
                    {labels.map((label, index) => {
                            const value = labels[index];
                            return (
                                <p> {label}
                                    <span class="float-end">{value}</span>
                                </p>
                            );
                        })}
                    </div>  */}
      </div>
    </div>
  )
}
